import { MESSAGE_TYPES } from '../constants/message';
import { PRECHAT_CAPTURE_TEMPLATES } from '../constants/prechat-capture';

/**
 * Returns the Prechat Capture form with fields properly formatted with their respective custom strings according to the chosen template
 *
 * @param {Object} prechatCaptureConfig - The `config.prechatCapture` configuration coming from the Redux store
 * @param {Object} text  - The `ui.text` configuration containing the custom UI strings coming from the Redux store
 * @param {Object} onSubmit  - The callback on Prechat Capture form submission
 * @return {Object} A Prechat Capture form
 */
export function getPrechatCaptureForm(prechatCaptureConfig, text, onSubmit) {
    const fields = getPrechatCaptureFields(prechatCaptureConfig, text);

    return {
        _id: 'prechat-capture-form',
        role: 'appMaker',
        type: MESSAGE_TYPES.FORM,
        received: Date.now() / 1000,
        fields,
        submitted: false,
        blockChatInput: true,
        submitPrechatCapture: onSubmit,
        isPrechatCaptureForm: true,
    };
}

/**
 * Returns the Prechat Capture fields properly formatted with their respective custom strings according to the chosen template
 *
 * @param {Object} prechatCaptureConfig - The `config.prechatCapture` configuration coming from the Redux store
 * @param {Object} text  - The `ui.text` configuration containing the custom UI strings coming from the Redux store
 * @return {Array<Object>} Prechat Capture form fields
 */
function getPrechatCaptureFields(prechatCaptureConfig, text) {
    const fields = prechatCaptureConfig.fields;

    switch (prechatCaptureConfig.template) {
        case PRECHAT_CAPTURE_TEMPLATES.NameEmail:
            fields[0].label = text.prechatCaptureNameLabel;
            fields[0].placeholder = text.prechatCaptureNamePlaceholder;
            fields[0]._id = text.prechatCaptureNameLabel;
            fields[1].label = text.prechatCaptureEmailLabel;
            fields[1].placeholder = text.prechatCaptureEmailPlaceholder;
            fields[1]._id = text.prechatCaptureEmailLabel;
            break;
        default:
            // Leave custom form as it is
            break;
    }

    return fields;
}
